import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-label="Garantía de devolución" className="bg-white" data-id="element-95" data-mp="1o46konudlsx5">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 py-16 text-center lg:py-20" style={{
      paddingTop: "11px",
      paddingBottom: "23px"
    }} data-id="element-96" data-mp="1o5zrc34zod55">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-perf/15" data-id="element-97" data-mp="1x5mvgwp3rx1w">
          <ShieldCheckIcon className="h-8 w-8 text-perf-deep" aria-hidden="true" data-id="element-98" data-mp="19fsj0g8p4ai6" />
        </span>
        <h2 className="mt-6 font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-99" data-mp="14gpcerd2hw83">
          Garantía de devolución de 7 días
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-navy/75" data-id="element-100" data-mp="1ee3sgpv2wizv">
          Si durante los primeros 7 días decides que SISTEMA TRIATLÓN COMPLETO™ no es adecuado para tus
          necesidades, podrás solicitar la devolución conforme a las condiciones de la garantía y recibir el
          reembolso del importe de tu compra.
        </p>
        <p className="mt-4 text-[17px] leading-relaxed text-navy/75" data-id="element-101" data-mp="oyqeiaqr5zk7">
          Puedes explorar el material sin asumir un compromiso financiero a largo plazo.
        </p>
        <p className="mt-6 text-sm font-bold uppercase tracking-[0.2em] text-navy" data-id="element-102" data-mp="yot749typbi0">
          Sigma Smart™ respalda la calidad de sus productos digitales.
        </p>
      </div>
    </section>;
}